import { createElement } from 'react';
import PropTypes from 'prop-types';
import localeEs from 'date-fns/locale/es';
import { distanceInWordsToNow, format, isValid } from 'date-fns';

import {
  withPropsOnChange,
  compose,
  setDisplayName,
  setPropTypes,
  defaultProps,
  pure
} from 'recompose';

const DateComponent = ({ className, date, children, element }) =>
  createElement(
    element,
    {
      className,
      dateTime: element === 'time' ? format(children, 'YYYY-MM-DD hh:mm') : null
    },
    date
  );

function validDate(date) {
  return isValid(new Date(date));
}

function formatDate(props) {
  if (!props.children) {
    return null;
  }

  const date = new Date(props.children);

  if (!validDate(date)) {
    return null;
  }

  const formatInDate = props.format || 'DD/MM/YYYY';

  if (props.fromNow) {
    return distanceInWordsToNow(date, {
      addSuffix: true,
      locale: localeEs
    }).replace('alrededor de', '');
  }

  return format(date, formatInDate, { locale: localeEs });
}

export default compose(
  setDisplayName('DateFormatCore'),
  withPropsOnChange(['children'], props => ({
    date: formatDate(props),
    error: validDate(props.children)
  })),
  setPropTypes({
    children: PropTypes.string,
    format: PropTypes.string,
    fromNow: PropTypes.bool,
    element: PropTypes.string
  }),
  defaultProps({
    element: 'time'
  }),
  pure
)(DateComponent);
